/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationconversationchannel2Inputs */

const en_moderationconversationchannel2 = /** @type {(inputs: Moderationconversationchannel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel`)
};

const de_moderationconversationchannel2 = /** @type {(inputs: Moderationconversationchannel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanal`)
};

/**
* | output |
* | --- |
* | "Channel" |
*
* @param {Moderationconversationchannel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationconversationchannel2 = /** @type {((inputs?: Moderationconversationchannel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationconversationchannel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationconversationchannel2(inputs)
	return de_moderationconversationchannel2(inputs)
});
export { moderationconversationchannel2 as "moderationConversationChannel" }